var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"h-screen background"},[_c(_setup.PageHeader),_c(_setup.PageContainer),_c(_setup.CookieBanner)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }